/**
 * this file contains all redux-saga watchers & workers for the transaction
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Tom on 19/06/18
 */

import { takeEvery, call, put } from "redux-saga/effects";
import moment from "moment";

import C from "../constants";
import config from "../config";
import { request, isEmpty, substitute } from "../utility/utilities";

// import action creators
import * as PortfolioActions from "../actions/portfolioActions";

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE PORTFOLIO GRAPH
----------------------------------------------------------------------------- */

// watcher saga for fetching the portfolio data
export function* watchFetchPortfolio() {
    yield takeEvery(C.FETCH_PORTFOLIO_DATA, workerFetchPortfolio);
}

// worker saga for fetching the portfolio data
function* workerFetchPortfolio() {
    // set the headers
    const headers = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        },
        mode: "cors", // NOTE: make sure Mulesoft endpoint allows CORS !!!!!!
        cache: "default"
    };

    // set the endpoint
    const startDate = moment()
            .subtract(6, "months")
            .format("YYYY-MM-DD"),
        endDate = moment().format("YYYY-MM-DD"),
        requestURL = substitute(config.endpoints.portfolioFetchURL, {startDate: startDate, endDate: endDate})

    try {
        // show the loader
        yield put(PortfolioActions.showPortfolioLoader(true));

        // get the response promise object
        const response = yield call(request, requestURL, headers);

        if (!isEmpty(response.data) && response.data.current_value > 0 ) {
            // get the array of transaction objects
            const bankAccountDetails = response.data;

            // set the postfolio bar data
            let fundHistory = bankAccountDetails.history

            // If cron hasn't run to generate bar data but fun history has value use it for today's value
            // Or history not be return but today's value is available
            if(!fundHistory || !fundHistory.length )
                fundHistory = [{date_created:endDate, fund_value:bankAccountDetails.current_value}];

            yield put(
                PortfolioActions.setPortfolioData(fundHistory)
            );

            // set fund value
            yield put(
                PortfolioActions.setPortfolioFundValue(
                    parseFloat(bankAccountDetails.current_value, 10)
                )
            );

            // set the success flag to true
            yield put(PortfolioActions.setPortfolioFetchSuccess(true));
        }
    } catch (error) {
        // set the success flag to false
        yield put(PortfolioActions.setPortfolioFetchSuccess(false));
    } finally {
        // hide the loader regardless
        yield put(PortfolioActions.showPortfolioLoader(false));
    }
}



// WEBPACK FOOTER //
// ./src/sagas/portfolioSaga.js